<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
  additionalAttributes: { type: Object, default: () => ({}) },
});

const failedToLoad = ref(false);
const header = computed(
  () =>
    props.additionalAttributes?.templateParams?.processedParams?.header || {}
);
const imageUrl = computed(() =>
  header.value.mediaType === 'image' ? header.value.mediaUrl || '' : ''
);

watch(imageUrl, () => {
  failedToLoad.value = false;
});
</script>

<template>
  <div class="contents">
    <img
      v-if="imageUrl && !failedToLoad"
      :src="imageUrl"
      alt=""
      class="max-h-80 w-full rounded-lg object-contain"
      loading="lazy"
      @error="failedToLoad = true"
    />
  </div>
</template>
